import { cn } from 'utils/cn';
import { Avatar } from '../Avatar';
import { CustomItemProps } from '../MultiSelect';
import Tooltip, { TooltipTrigger } from '../Tooltip';

const SelectTeamMemberItem = ({ option, selected, disabled }: CustomItemProps) => {
    return (
        <div
            className={cn(
                'flex items-center gap-2 p-1 justify-between w-full',
                selected && 'bg-primary/10',
                disabled && 'opacity-50'
            )}
        >
            <div className='flex flex-row gap-1.5 items-center '>
                <Avatar
                    size="sm"
                    borderRadius='md'
                    title={option.label}
                    src={option.src as string}
                    email={option.email as string}
                />
                <div className="font-medium text-textcolor">{option.label}</div>
                {option.description && (
                    <div className="text-sm text-muted-foreground ">{option.description}</div>
                )}
                <span className="text-xs text-gray-500 capitalize">{option.role}</span>
            </div>
            {
                option.selected &&
                <span className=" flex justify-end grow">
                    <Tooltip content="User has already been added to this project">
                        <TooltipTrigger asChild>
                            <span className='text-xs text-gray-500'>Already in this project</span>
                        </TooltipTrigger>
                    </Tooltip>
                </span>
            }
        </div>
    );
};

export default SelectTeamMemberItem;

SelectTeamMemberItem.displayName = 'SelectTeamMemberItem';